<button *ngIf="isVisible"
        id="{{buttonId}}"
        ftsAuditableButton
        ftsAsyncButton
        class='btn btn-block text-uppercase action-btn font-secondary'
        [ngClass]="{
          'loading-button': disableCheckout,
          'btn-link btn-undecorated action-text-color btn-checkout-inverted secondary-btn': inverted,
          'action-bg-color action-inverse-text-color primary-btn': !inverted,
          'btn-checkout': !reduceBtnSize && !inverted,
          'btn-checkout-sm wrap-text': reduceBtnSize
        }"
        [subscription]="loadingCheckoutPageSubsciption"
        (click)="handleCheckoutClick()"
        >
  {{(isUpsell ? 'component.checkout_button.continue_checkout' : groupOrder?.isLeader ? 'component.checkout_button.leader_checkout' : 'component.checkout_button.checkout') | translate }}
</button>
